import type { StatusPillProps } from '@vnetwork/ui/data';

type Tone = NonNullable<StatusPillProps['tone']>;

/**
 * Map a free-form status string (approved / pending / rejected / paid …) to a
 * StatusPill tone. Shared across the account tabs so day-off, business, on-call
 * and compensation statuses read consistently.
 */
export function statusTone(status?: string | null): Tone {
  const s = (status ?? '').toLowerCase();
  if (/(approved|confirmed|active|completed|paid|success)/.test(s)) return 'success';
  if (/(pending|processing|waiting|scheduled)/.test(s)) return 'warning';
  if (/(rejected|cancelled|canceled|failed|declined)/.test(s)) return 'danger';
  return 'muted';
}
